var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncorrectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20Z",
    fill: "url(#paint0_linear_3810_3928)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63081 5.75433L6.68993 5.80605L10 9.11625L13.311 5.80714L13.3702 5.75541C13.6162 5.56589 13.9706 5.58483 14.1949 5.81116C14.4192 6.03748 14.4349 6.39208 14.2432 6.63639L14.1909 6.69503L10.8844 10L14.1901 13.3057C14.4353 13.5487 14.4371 13.9444 14.1941 14.1896C13.9698 14.4159 13.6154 14.4349 13.3693 14.2453L13.3102 14.1936L10 10.8831L6.69055 14.1925L6.63144 14.2442C6.38539 14.4337 6.03095 14.4148 5.80668 14.1885C5.5824 13.9622 5.56668 13.6076 5.75844 13.3632L5.8107 13.3046L9.11625 10L5.81007 6.69395C5.56489 6.45098 5.56309 6.05526 5.80605 5.81007C6.03033 5.58375 6.38477 5.56481 6.63081 5.75433Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3810_3928",
    x1: -2.98023e-7,
    y1: 20,
    x2: 23.8939,
    y2: 7.3619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A7A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncorrectIcon);
export default __webpack_public_path__ + "static/media/incorrect_icon.f3ac6e09c9a5c37bd11112f1ca68d94c.svg";
export { ForwardRef as ReactComponent };